import { IconButton, Tooltip } from '@mui/material';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import { useTranslation } from 'react-i18next';
import { useAssistantStore } from '@/stores/assistantStore';

export function AssistantToggleButton() {
  const { t } = useTranslation('assistant');
  const toggleOpen = useAssistantStore((s) => s.toggleOpen);

  return (
    <Tooltip title={t('openPanel')}>
      <IconButton
        onClick={toggleOpen}
        sx={{ ml: 1 }}
        aria-label={t('openPanel')}
      >
        <SmartToyOutlinedIcon />
      </IconButton>
    </Tooltip>
  );
}
